<app-header></app-header>
<app-right-side></app-right-side>
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css">
<div *ngIf="isLoaderVisible" class="preloader js-preloader">
    <img src="assets/img/loader.webp">
</div>


<div class="container">
    <div class="row">
        <!-- Main Content -->
        <main class="col col-xl-8 order-xl-2 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12" >
            <div class="ui-block" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <!-- News Feed Form  -->
                <div class="news-feed-form" >
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist"  style="display: none;">
                        <li class="nav-item">
                            <a class="nav-link active inline-items" data-toggle="tab" href="#home-1" role="tab"
                                aria-expanded="true">

                                <svg class="olymp-status-icon">
                                    <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-status-icon">
                                    </use>
                                </svg>

                                <span>Post</span>
                            </a>
                        </li>

                    </ul>

                    <!-- Tab panes -->
                    <div class="tab-content" >
                        <div class="tab-pane active" id="home-1" role="tabpanel" aria-expanded="true">
                            <form [formGroup]="postForm" (ngSubmit)="setPost()">
                                <div class="row">
                                    <div class="col-lg-2" style="margin: 0px auto;">
                                        <img *ngIf="!currentUser.success.user.avatar" src="assets/img/author-main1.webp"
                                        class="img-responsive img-fluid" alt="author" >
                                        <img *ngIf="currentUser.success.user.avatar" alt="author" [src]="userData[0].avatar"
                                        onerror="this.onerror=null; this.src='assets/img/author-main1.webp';"
                                        class="img-responsive img-fluid avatar img1" style=" width: 120px; height: 120px; padding: 10px;">     
                                    </div>
                                    <div class="col-lg-10" style="text-align: left; position: relative; right: 25px; top:18px">
                                        <textarea class="form-control1" formControlName="content"
                                        placeholder="{{'profile.share_here' | translate}}" style="width: 100%; height: 80px; border-radius: 10px; border-color: #eceaea; background-color: var(--background-color); color: var(--text-color);"></textarea>
                                    </div>
                                </div>
                                <div class="add-options-message">
                                    <input style="display: none;" type="file" name="image" formControlName="image"
                                        #image (change)="onImageSelect($event)">
                                    <a href="javascript:void(0);" (click)="image.click()" class="options-message"
                                        data-toggle="tooltip" data-placement="top" data-original-title="Add File" style="color:#3e758f">
                                            <i class="fas fa-image"></i>
                                        <Label style="margin: 0px 25px;"> {{imageName}}</Label>
                                    </a>
                                    <input style="display: none;" type="file" name="video" formControlName="video"
                                        #video (change)="onVideoSelect($event)">
                                    <a href="javascript:void(0);" (click)="video.click()" class="options-message"
                                        data-toggle="tooltip" data-placement="top" data-original-title="Add Video" style="color:#3e758f">
                                            <i class="fas fa-video"></i>
                                        <Label style="margin: 0px 25px;"> {{videoName}}</Label>
                                    </a>
                                    <button class="btn btn-md-2 btn-primary"  style="background-color: #3e758f; color:#fff; border-radius: 5px; font-size: 15px;">
                                        <i class="fad fa-pen-square"></i>&nbsp; Post 
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- ... end News Feed Form  -->
            </div>
            <div id="newsfeed-items-grid">
                <div *ngFor="let post of posts" class="ui-block" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                    <article class="hentry post">
                        <div class="post__author author vcard inline-items">
                            <a routerLink="/friend-about" [queryParams]="{'id': post.user_id}"><img
                                *ngIf="!post.user.avatar" src="assets/img/author-main1.webp" alt="author"> 
                            </a>
                            <a routerLink="/friend-about" [queryParams]="{'id': post.user_id}"><img
                                *ngIf="post.user.avatar" alt="author" [src]="post.user.avatar"
                                onerror="this.onerror=null; this.src='assets/img/author-main1.webp';"
                                class=" avatar img-responsive img-fluid" style=" width: 60px; height: 60px; padding: 2px;"> 
                            </a>
                            <div class="author-date">
                                <a class=" post__author-name fn" routerLink="/friend-about" [queryParams]="{'id': post.user_id}" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                                    {{post.user.fullName | titlecase}}
                                </a> 
                                <br>
                                <time class="published" datetime="2004-07-24T18:18" style="font-size: 12px;">
                                    Last Update {{calculateDiff(post.created_at | date: 'yyyy-MM-dd')}}
                                </time>
                            </div>
                            <div *ngIf="post.user_id === currentUser.success.user.id" class="more"><svg
                                    class="olymp-three-dots-icon">
                                    <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon">
                                    </use>
                                </svg>
                                <ul class="more-dropdown">
                                    <li>
                                        <a (click)="openEditModal(postEditModal,post)">Edit Post</a>
                                    </li>
                                    <li>
                                        <a (click)="openDeleteModal(postDeleteModal,post)">Delete Post</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <hr style="background-color: var(--text-color2);">
                        <p style="font-size: 15px; font-family:Myriad Pro;"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                            <Label [innerHTML]="urlify(post.content)" style="background-color: var(--backgroundpost-color); color: var(--text-color);"></Label>
                        </p>
                        <div class="post-thumb">
                            <img *ngIf="post.image" [src]="post.image" alt="Image ">
                            <video *ngIf="post.video" id="my_video_1" class="video-js vjs-default-skin" width="100%"
                                height="auto" controls muted
                                data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
                                <source [src]="post.video" type='video/mp4' />
                                <source [src]="post.video" type="video/webm">
                                Sorry, your browser doesn't support embedded videos.
                            </video>
                            <p *ngIf="post.document">Click Here! <a href="{{post.document}}">{{post.content}}</a>.</p>
                        </div>
                        <div >
                            <a (click)="likeUnlike(post.id)" style="font-size: 15px;">
                                <i class="fad fa-thumbs-up" style="color: #e01b0d;"></i>&nbsp;
                                <span>{{post.likesCounter}}</span>
                            </a>
                            &nbsp; | &nbsp;
                            <a (click)="toggle(post.id)" style="text-align: left; font-size: 15px;">
                                <i class="fad fa-comments" style="color: #000000;"></i>&nbsp;
                                <span>{{post.commentsCounter}}</span>
                            </a>
                        </div>
                    </article>
                    <!-- Comments -->
                    <ul *ngIf="show && show === post.id" class="comments-list" >
                        <li *ngFor="let comment of comments" class="comment-item" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                            <div class="post__author author vcard inline-items">
                                <img *ngIf="!comment.avatar" src="assets/img/author-main1.webp" width="30"
                                    height="30" alt="author" class="mCS_img_loaded">
                                <img *ngIf="comment.avatar" alt="author" [src]="comment.avatar" class="mCS_img_loaded"
                                    width="30" height="30">

                                <div class="author-date">
                                    <a class="h6 post__author-name fn"> {{ comment.fullName | titlecase}}</a>
                                    <div class="post__date" style="font-size: 12px; background-color: var(--backgroundpost-color); color: var(--text-color);">
                                        <time class="publish1ed">
                                            {{calculateDiff(comment.commdate)}}
                                        </time>
                                    </div>
                                </div>
                                <a (click)="openCommentDeleteModal(commentDeleteModal, comment , post.id)"
                                    class="more"><i *ngIf="currentUser.success.user.id === comment.user_id"
                                        class="fa fa-trash" aria-hidden="true"></i></a>

                            </div>
                            <p style="background-color: var(--backgroundpost-color); color: var(--text-color);">{{ comment.commentsContent}}</p>
                        </li>
                        <!-- Comment Form  -->
                        <form [formGroup]="commentForm" (ngSubmit)="doComment(post.id)"
                            class="comment-form inline-items">

                            <div class="post__author author vcard inline-items">
                                <img *ngIf="!currentUser.success.user.avatar"
                                    src="assets/img/author-main1.webp" alt="author">
                                <img *ngIf="currentUser.success.user.avatar" alt="author"
                                    [src]="currentUser.success.user.avatar" class="avatar" width="28" height="28">

                                <div class="form-group with-icon-right ">
                                    <input class="form-control" formControlName="content" placeholder="" type="text" type="text" style="width: 100%; height: 80px; border-radius: 10px; border-color: #eceaea; background-color: var(--backgroundpost-color); color: var(--text-color);">
                                </div>
                            </div>
                            <button class="btn btn-md-2 btn-primary" style="background-color: #3e758f; color:#fff; border-radius: 5px; font-size: 15px;"><i class="fad fa-comment-dots"></i>&nbsp;Comment
                            </button>
                        </form>
                        <!-- ... end Comment Form  -->
                    </ul>
                </div>
            </div>
        </main>
        <!-- ... end Main Content -->
        <!-- Right Sidebar -->
        <aside class="col col-xl-4 order-xl-3 col-lg-6 order-lg-3 col-md-6 col-sm-6 col-12">
            <div class="ui-block" >
                <div class="date-and-place" style="padding: 10px; font-size: 25px; background-color: #af6016; color: #d4d4d4; border: 3px solid #fff;">
                    <h4 class="date1" style="color: #fff;"><i class="bi bi-calendar3"></i>&nbsp;{{today | date: 'fullDate'}}</h4>
                </div>
            </div>
            <div class="ui-block" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                        <div class="ui-block-title"  style="background-color: #272626; color: #fff;">
                            <h6 class="title" style="color: #fff;"><i class="fad fa-newspaper"></i>&nbsp;Voting </h6>
                        </div>
                        <div class="ui-block-content" style="text-align: center;">
                            <a  routerLink="/voting" class="table"
                                style="background-image: url('assets/img/Vote2025.png'); height: 300px; width: 300px; position: relative; left: 25px; top:-10px">
                            </a>
                        </div>

            </div>
            <div class="ui-block" style="display: none;">
                <div class="ui-block-title" style="background-color: #272626; color: #fff;">
                    <h6 class="title" style="color: #fff;">Friend Suggestions</h6>
                    <!-- <a href="javascript:void(0);" class="more"><svg class="olymp-three-dots-icon"><use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use></svg></a> -->
                </div>
                <br>
                <div class="row">
                    <div *ngFor="let friend of suggestedFriends" class="col-lg-4">
                        <div class="author-thumb" style="position: relative; left:15px">
                            <img *ngIf="!friend.avatar" src="assets/img/author-main1.webp" alt="author"
                                style="height: 60px;width: 60px;">
                            <img *ngIf="friend.avatar" [src]="friend.avatar" alt="author"
                                style="height: 60px;width: 60px;">
                        </div>
                    </div>
                </div>

                <!-- ... end W-Action -->
            </div>
            <div class="ui-block" style="text-align: center; background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title"  style="background-color: #272626; color: #fff;">
                    <h6 class="title" style="color:#fff;"><i class="bi bi-question-circle-fill"></i>&nbsp;{{'profile.voting_q' | translate}}</h6>
                </div>
                
                <div class="ui-block-content">
                    <div *ngFor="let item of votes" style="font-size: 20px; width: 100%;" dir="ltr">
                    <div *ngIf="item.QExpDate>  currentDate">
                        <div *ngIf="item.Qstatus == 1">
                        <form [formGroup]="FanvoteForm" (ngSubmit)="setvotfan()">
                            <fieldset style="text-align: left;">
                                <div style="font-size: 18px;">
                                    <Label  formControlName="VoQuest" name="VoQuest" style="border-radius: 0px; width: 100%; color: var(--text-color); border: 0px; font-weight: 600;">{{item.VoteQ}}</Label>
                                    <Label formControlName="VoteNo" name="VoteNo1" style="display: none;"> {{item.Qnumber}} </Label>
                                    <Label formControlName="Votedate" name="VoteNo1" style="display: none;">{{currentDate}}</Label>
                                </div>
                                
                                <div *ngFor="let itemtotal of QAll">
                                    <label style="font-size: 15px; color: var(--text-color);"><input type="radio" id="A11" formControlName="QVA" name="QVA" [value]="item.VoteA1" />{{item.VoteA1}}&nbsp;(
                                        <span *ngFor="let item2 of QA11">
                                            <span *ngIf="item2.CFA1 == ''">0%</span>
                                            <span *ngIf="item2.CFA1 != ''">{{(item2.CFA1 /itemtotal.CFAll * 100).toFixed(2)}}%</span>
                                        </span>
                                        )</label>
                                    <div class="meter"><span *ngFor="let item1 of QA11" [style.width.%] ="item1.CFA1 /itemtotal.CFAll * 100"></span></div>
                                </div>
                            
                                <div *ngFor="let itemtotal of QAll">
                                    <label style="font-size: 15px; color:  var(--text-color);"><input type="radio" id="A22" formControlName="QVA" name="QVA" [value]="item.VoteA2" />{{item.VoteA2}}&nbsp;(
                                        <span *ngFor="let item3 of QA12">
                                            <span *ngIf="item3.CFA2 == ''">0%</span>
                                            <span *ngIf="item3.CFA2 != ''">{{(item3.CFA2 /itemtotal.CFAll * 100).toFixed(2)}}%</span>
                                        </span>
                                        )</label>
                                    <div class="meter"><span *ngFor="let item3 of QA12" [style.width.%] ="item3.CFA2 /itemtotal.CFAll * 100"></span></div>
                                </div>
                                <div *ngFor="let itemtotal of QAll">
                                    <div *ngIf="item.VoteA3 != ''">
                                    <label style="font-size: 15px; color:  var(--text-color);"><input type="radio" id="A33" formControlName="QVA" name="QVA" [value]="item.VoteA3" />{{item.VoteA3}}&nbsp;(
                                        <span *ngFor="let item4 of QA13">
                                            <span *ngIf="item4.CFA3 == ''">0%</span>
                                            <span *ngIf="item4.CFA3 != ''">{{(item4.CFA3 /itemtotal.CFAll * 100).toFixed(2)}}%</span>
                                        </span>)
                                    </label>
                                    <div class="meter"><span *ngFor="let item4 of QA13" [style.width.%] ="item4.CFA3 /itemtotal.CFAll * 100"></span></div>
                                </div></div>
                            </fieldset>
                            <br>
                            
                            <div>
                                <button formControlName="btnvote" class="btn btn-danger" type="submit" name="" style="background-color: #c4492a; border-radius: 10px; font-size: 18px;"><i class="bi bi-hand-index-thumb-fill"></i> &nbsp;Vote</button>
                            </div>
                            <p style="font-size: 12px;  color:var(--text-color)">Vote finish tell {{item.QExpDate}}</p>
                        </form>
                    </div></div></div>
                    
                </div></div>
             <div class="ui-block"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title"  style="background-color: #272626; color: #fff;">
                    <h6 class="title" style="color:#fff;"><i class="fad fa-smog"></i>&nbsp;Weather</h6>
                </div>
                <div class='wrapper' style="text-align: left;">
                <div class='panel' style="text-align: left;">
                    <h4 class='city' id='city' style="color: var(--text-color);"></h4>
                    <div class='weather' id='weather'>
                    <div class='group secondary'>
                        <h5 id='dt'  style="color: var(--text-color);"></h5>
                        <h5 id='description'  style="color: var(--text-color);"></h5>
                    </div>
                    <div class='group secondary'>
                        <h5 id='wind'  style="color: var(--text-color);"></h5>
                        <h5 id='humidity'  style="color: var(--text-color);"></h5>
                    </div>
                    <div class='temperature' id='temperature'>
                        <h3 class='temp' id='temp'  style="color: var(--text-color);"><i id='condition'></i> <span id='num'></span><a class='fahrenheit active' id='fahrenheit' href="#"  style="color: var(--text-color);">&deg;F</a><span class='divider secondary'>|</span><a class='celsius' id='celsius' href="#">&deg;C</a></h3>
                    </div>
                    <br>
                    </div>
                </div>
            </div></div>
        </aside>

        <!-- ... end Right Sidebar -->

    </div>
</div>


<!-- Delete Modal -->
<div class="modal fade" bsModal #postDeleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" style="color: var(--text-color);">Delete Post</h5>
                <button type="button" class="close" (click)="postDeleteModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <label style="color: var(--text-color);">Are you Sure you want to delete Post</label>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="postDeleteModal.hide()">No</button>
                <button type="button" class="btn btn-danger" (click)="deletePost(postDeleteModal)">Yes</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" bsModal #commentDeleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content" >
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" style="color: var(--text-color);">Delete Comment</h5>
                <button type="button" class="close" (click)="commentDeleteModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <label style="color: var(--text-color);">Are you Sure you want to delete Comment</label>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="commentDeleteModal.hide()">No</button>
                <button type="button" class="btn btn-danger"
                    (click)="deleteComment(commentDeleteModal,selectPostId)">Yes</button>
            </div>
        </div>
    </div>
</div>
<!-- Delete Modal -->

<!-- Edit   Modal -->
<div class="modal fade" bsModal #postEditModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" style="color: var(--text-color);">Edit Post </h5>
                <button type="button" class="close" (click)="closeEditModal(postEditModal)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form #postEditForm="ngForm">
                    <div class="form-group">
                        <label style="padding-right: 290px;" for="projectDescription">
                            <b style="color: var(--text-color);">Post Description</b>
                        </label>
                        <textarea class="form-control" name="content" #content="ngModel" 
                            [(ngModel)]="selectPost.content" rows="2" required autocomplete="off" style="background-color: var(--background-color); color: var(--text-color);"></textarea>
                    </div>
                    <div class="form-group">
                        <label for="projectEndDate">
                            <b style="color: var(--text-color);">Attachment</b>
                        </label>
                        <img *ngIf="selectPost.image" [src]="selectPost.image" alt="Photo"  style="width: 100%; height: 400px; border:0px solid #fff; border-radius: 0px; object-fit: cover;">
                        <input type="file" class="form-contro1l" name="attachment" #attachment="ngModel"
                            [(ngModel)]="selectPost.attachment" (change)="onImageSelect($event)" style="width: 100%; height: 100px; border:0px solid #fff; border-radius: 0px;">

                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="bt1n bt1n-secondary" (click)="closeEditModal(postEditModal)">Close</button>
                <button type="button" class="bt1n bt1n-primary" (click)="updatePost(postEditModal)"
                    [disabled]="!postEditForm.form.valid">Save changes</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit   Modal -->